var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "b-container",
    { attrs: { fluid: "" } },
    [
      _c("admin-preloader", { attrs: { show: _vm.loading } }),
      _vm._v(" "),
      _c("admin-breadcrumb", { attrs: { name: "Dashboard" } }),
      _vm._v(" "),
      _c(
        "b-row",
        [
          _c(
            "b-col",
            { attrs: { md: "6" } },
            [
              _c(
                "admin-panel",
                {
                  attrs: {
                    title: "Recent Applications",
                    "sub-title":
                      "Companies applications that have not been verified yet",
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "header-right",
                      fn: function () {
                        return [
                          _c(
                            "div",
                            [
                              _vm.pending_applications.rows.length > 0
                                ? _c(
                                    "b-btn",
                                    {
                                      attrs: {
                                        variant: "primary",
                                        to: { name: "admin-applications" },
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n             View All\n           "
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                            ],
                            1
                          ),
                        ]
                      },
                      proxy: true,
                    },
                  ]),
                },
                [
                  _vm._v(" "),
                  _c(
                    "b-overlay",
                    { attrs: { show: _vm.pending_applications.loading } },
                    [
                      _c("admin-applications-table", {
                        attrs: {
                          applications: _vm.pending_applications.rows,
                          small: "",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-col",
            { attrs: { md: "6" } },
            [
              _c(
                "admin-panel",
                { attrs: { title: "Last Approved Companies" } },
                [
                  _c(
                    "b-overlay",
                    { attrs: { show: _vm.last_approved_companies.loading } },
                    [
                      _c("admin-companies-table", {
                        attrs: {
                          companies: _vm.last_approved_companies.rows,
                          small: "",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-row",
        [
          _c(
            "b-col",
            [
              _c(
                "admin-panel",
                {
                  attrs: {
                    title: "Licenses Awaiting Approval",
                    "sub-title": "Licenses that have not been confirmed",
                  },
                },
                [
                  _c(
                    "b-overlay",
                    { attrs: { show: _vm.not_approved_licenses.loading } },
                    [
                      _c("admin-licenses-table", {
                        attrs: {
                          licenses: _vm.not_approved_licenses.rows,
                          "with-actions": "",
                          "with-company": "",
                        },
                        on: { approve: _vm.requestApproveLicense },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _vm.license_to_approve
                ? _c("admin-license-approve-modal", {
                    attrs: { license: _vm.license_to_approve, visible: "" },
                    on: {
                      approve: _vm.approveLicense,
                      cancel: function ($event) {
                        _vm.license_to_approve = null
                      },
                    },
                  })
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-row",
        [
          _c(
            "b-col",
            { attrs: { lg: "8", md: "7" } },
            [
              _c(
                "admin-panel",
                { attrs: { title: "Last Registered Users" } },
                [
                  _c(
                    "b-overlay",
                    { attrs: { show: _vm.last_registered_users.loading } },
                    [
                      _c("admin-users-table", {
                        attrs: {
                          users: _vm.last_registered_users.rows,
                          "no-avatar": "",
                          small: "",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-col",
            { attrs: { lg: "4", md: "5" } },
            [
              _c(
                "admin-panel",
                {
                  attrs: {
                    title: "Current Stats",
                    "sub-title": "General GreenLists Stats",
                  },
                },
                [
                  _vm.total_companies !== null
                    ? _c("h5", [
                        _vm._v("Total Companies: "),
                        _c("strong", [_vm._v(_vm._s(_vm.total_companies))]),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.active_companies !== null
                    ? _c("h5", [
                        _vm._v("Active Companies: "),
                        _c("strong", [_vm._v(_vm._s(_vm.active_companies))]),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.total_users !== null
                    ? _c("h5", [
                        _vm._v("Total Users: "),
                        _c("strong", [_vm._v(_vm._s(_vm.total_users))]),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.active_users !== null
                    ? _c("h5", [
                        _vm._v("Active Users: "),
                        _c("strong", [_vm._v(_vm._s(_vm.active_users))]),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.total_licenses !== null
                    ? _c("h5", [
                        _vm._v("Total Facilities: "),
                        _c("strong", [_vm._v(_vm._s(_vm.total_licenses))]),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.active_licenses !== null
                    ? _c("h5", [
                        _vm._v("Active Facilities: "),
                        _c("strong", [_vm._v(_vm._s(_vm.active_licenses))]),
                      ])
                    : _vm._e(),
                ]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }